var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inward"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off",
      "onSubmit": "return false"
    }
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": _vm.$t('rtogrnb2b.rtoShipmentTitle')
    },
    on: {
      "click": function($event) {
        _vm.tabChanged(1)
      }
    }
  }, [(_vm.isRTO) ? _c('form', {
    attrs: {
      "autocomplete": "off",
      "onSubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isValidAWB) ? _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    }
  }, [_c('a', {
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('rtogrnb2b.expandAll')) + "\n                  ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.rtoGrnb2bTiltle')))]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading1
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading1 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('fieldset', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbNo')
    },
    attrs: {
      "type": "string",
      "disabled": _vm.isValidAWB,
      "placeholder": _vm.$t('handover.awbnoPlaceholder'),
      "name": "awbNo",
      "id": "awbNo"
    },
    model: {
      value: (_vm.globalObject.awbNo),
      callback: function($$v) {
        _vm.globalObject.awbNo = $$v
      },
      expression: "globalObject.awbNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbNo')),
      expression: "errors.has('awbNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('awbNo')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.awbEntered()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.isValidAWB) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [(_vm.globalObject.merchantName) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.merchant')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderID) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderDate) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.orderDate')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.whReceivedDate) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.whReceivedDate')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.transporter) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.transporter')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.globalObject.merchantName) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.merchantName))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderID) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.orderID))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderDate) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.globalObject.orderDate)))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.whReceivedDate) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.globalObject.whReceivedDate)))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.transporter) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.transporter))]) : _vm._e()])])])])]) : _vm._e()])])])])], 1)])]), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productDetails')) + " (" + _vm._s(this.globalObject.productDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.dispatchQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.productDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productDetailsNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.productDetails), function(data, index) {
    return (_vm.globalObject.productDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check3"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productQCTitle')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading3
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading3 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('productId')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('boxList.scanProduct'),
      "name": "productId",
      "id": "productId"
    },
    model: {
      value: (_vm.globalObject.productId),
      callback: function($$v) {
        _vm.globalObject.productId = $$v
      },
      expression: "globalObject.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm",
      "title": "Reset Product"
    },
    on: {
      "click": _vm.resetProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _vm._v(" "), (!_vm.isProductReject && _vm.showExpiryDate && !_vm.qcDoneReject) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('expirydate')
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('rtogrnb2b.expiryDatePlaceholder1'),
      "name": "expirydate",
      "id": "expirydate"
    },
    on: {
      "change": _vm.showQCButtonsForGrn
    },
    model: {
      value: (_vm.globalObject.expiryDate),
      callback: function($$v) {
        _vm.globalObject.expiryDate = $$v
      },
      expression: "globalObject.expiryDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP' && _vm.showrefurbished) ? _c('div', {
    staticClass: "col-md-12 my-2",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "margin-left": "-10px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isBoxchanged),
      expression: "isBoxchanged"
    }],
    attrs: {
      "type": "checkbox",
      "id": "boxchange1",
      "autocomplete": "off"
    },
    domProps: {
      "checked": Array.isArray(_vm.isBoxchanged) ? _vm._i(_vm.isBoxchanged, null) > -1 : (_vm.isBoxchanged)
    },
    on: {
      "change": function($event) {
        _vm.disabledAccept()
      },
      "__c": function($event) {
        var $$a = _vm.isBoxchanged,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isBoxchanged = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isBoxchanged = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isBoxchanged = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "boxchange"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.isBoxchange')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRefurbished),
      expression: "isRefurbished"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isRefurbished1"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRefurbished) ? _vm._i(_vm.isRefurbished, null) > -1 : (_vm.isRefurbished)
    },
    on: {
      "change": function($event) {
        _vm.disabledAccept()
      },
      "__c": function($event) {
        var $$a = _vm.isRefurbished,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRefurbished = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isRefurbished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRefurbished = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isRefurbished"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.isRefurbished')))])])]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.scanProductDetails.productQty),
      expression: "globalObject.scanProductDetails.productQty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.quantity'),
      "name": "productQty",
      "id": "productQty"
    },
    domProps: {
      "value": (_vm.globalObject.scanProductDetails.productQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalObject.scanProductDetails.productQty = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading3 || _vm.isRefurbished,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.productQC('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.accept')))]), _vm._v("  \n                            ")]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3 || _vm.isBoxchanged,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.productQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.reject')))])]) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.rejectReason),
      expression: "globalObject.rejectReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectReason')
    },
    attrs: {
      "name": "rejectReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.globalObject.rejectReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.reasonPlaceholder')))]), _vm._v(" "), _vm._l((_vm.globalObject.rejectList), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.reason
      }
    }, [_vm._v(_vm._s(reason.reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rejectReason')),
      expression: "errors.has('rejectReason')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.rejectReasonErr')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId && _vm.hideRejectbutton == false) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.completeProductQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reject")])]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.showQCButton) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.globalObject.scanProductDetails.productid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productType')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.globalObject.scanProductDetails.productid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.clientproductid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productname))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productdescription))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.globalObject.scanProductDetails.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productType))]) : _vm._e()])])])])]) : _vm._e()]), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType == 'NOP') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.imageDescription),
      expression: "imageDescription"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('imageDescription')
    },
    attrs: {
      "id": "imageDescription",
      "name": "imageDescription",
      "type": "text",
      "placeholder": _vm.$t('product.productDescription')
    },
    domProps: {
      "value": (_vm.imageDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageDescription = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.nopFound
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.markNop')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "10px",
      "background-color": "#673AB7"
    },
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printLabelNop
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.printNop')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "10px",
      "background-color": "#44b8bd"
    },
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printLabelNopPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.printNop')))])])]) : _vm._e(), _vm._v(" "), (_vm.uploadPictures) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProduct')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProductimg1')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProductimg2')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProductimg3')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.productUploadLabelUpload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadLabelUrl,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadLabelUrl)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadLabelUpload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.productUploadImage1Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadImage1Url,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadImage1Url)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadImage1Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.productUploadImage2Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadImage2Url,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadImage2Url)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadImage2Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.productUploadImage3Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadImage3Url,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadImage3Url)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadImage3Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Label"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('label', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Label"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('label', 'file')
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Image 1"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image1', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Image 1"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image1', 'file')
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Image 2"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image2', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Image 2"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image2', 'file')
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Image 3"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image3', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Image 3"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image3', 'file')
      }
    }
  })])])])])]), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.cameraSection = false
      }
    },
    model: {
      value: (_vm.cameraSection),
      callback: function($$v) {
        _vm.cameraSection = $$v
      },
      expression: "cameraSection"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading7
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading7 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('label', [_c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.uploadProductID')) + " [ " + _vm._s(this.globalObject.productId) + " ] " + _vm._s(this.imageType) + " ")])])])]), _vm._v(" "), (_vm.uploadPictures && _vm.cameraSection && _vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage(_vm.imageType, 'file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")])])]) : _vm._e(), _vm._v(" "), (_vm.uploadPictures && _vm.cameraSection && !_vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cameralist),
      expression: "cameralist"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cameralist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cameralist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cameraSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _vm._l((_vm.cameras), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.deviceId
      }
    }, [_vm._v(" " + _vm._s(client_obj.label))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('web-cam', {
    ref: "cameraImage",
    attrs: {
      "autoplay": "autoplay",
      "playsinline": _vm.playsinline,
      "height": 500,
      "width": 455,
      "screenshotFormat": _vm.screenshotFormat,
      "selectFirstDevice": _vm.selectFirstDevice
    },
    on: {
      "cameras": _vm.camerass
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.captureImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.capture')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.resetImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.retake')))])]), _vm._v(" "), (this.imageCaptured) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.saveImage(_vm.imageType, 'camera')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.viewImage = false
      }
    },
    model: {
      value: (_vm.viewImage),
      callback: function($$v) {
        _vm.viewImage = $$v
      },
      expression: "viewImage"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "width": "400px",
      "height": "400px"
    }
  })])], 1)], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check4"
    }
  }, [_vm._v(_vm._s(_vm.$t('rvpgrnb2b.extraProduct')) + " (" + _vm._s(this.globalObject.extraProductDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading4
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading4 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.quantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productDescription')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productImage')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.extraProductDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.$t('rvpgrnb2b.extraProductNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.extraProductDetails), function(data, index) {
    return (_vm.globalObject.extraProductDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productdescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('img', {
      attrs: {
        "src": data.productimage,
        "width": "100px",
        "height": "120px"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check5"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.excessProduct')) + " (" + _vm._s(this.globalObject.externalProductDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading5
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading5 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.quantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productDescription')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productImage')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.externalProductDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.excessProductPlaceholder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.externalProductDetails), function(data, index) {
    return (_vm.globalObject.externalProductDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productdescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('img', {
      attrs: {
        "src": data.productimage,
        "width": "100px",
        "height": "120px"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e()])]), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading6,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.checkCloseGR
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.closeGR')))])])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('rvpgrnb2b.rvpShipmentTitle')
    },
    on: {
      "click": function($event) {
        _vm.tabChanged(2)
      }
    }
  }, [(_vm.isRTV) ? _c('form', {
    attrs: {
      "autocomplete": "off",
      "onSubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isValidAWB) ? _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    }
  }, [_c('a', {
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('rtogrnb2b.expandAll')) + "\n                  ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('rvpgrnb2b.rvpGrnb2bTiltle')))]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading1
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading1 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('fieldset', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbNo')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('handover.awbnoPlaceholder'),
      "disabled": _vm.isValidAWB,
      "name": "awbNo",
      "id": "awbNo"
    },
    model: {
      value: (_vm.globalObject.awbNo),
      callback: function($$v) {
        _vm.globalObject.awbNo = $$v
      },
      expression: "globalObject.awbNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbNo')),
      expression: "errors.has('awbNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('awbNo')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.awbEntered()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(!_vm.isValidAWB && _vm.showOrderIdInput) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('orderID')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('common.orderIDPlaceholder'),
      "name": "orderID",
      "id": "orderID"
    },
    model: {
      value: (_vm.globalObject.orderID),
      callback: function($$v) {
        _vm.globalObject.orderID = $$v
      },
      expression: "globalObject.orderID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('orderID')),
      expression: "errors.has('orderID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('orderID')))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isValidAWB && _vm.showOrderIdInput) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.orderIdEntered()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('rvpgrnb2b.searchOrderBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB && _vm.isInitiated > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('orderID')
    },
    attrs: {
      "type": "string",
      "disabled": _vm.isOrderIdUpdated,
      "placeholder": _vm.$t('common.orderIDPlaceholder'),
      "name": "orderID",
      "id": "updatedOrderID"
    },
    model: {
      value: (_vm.updatedOrderId),
      callback: function($$v) {
        _vm.updatedOrderId = $$v
      },
      expression: "updatedOrderId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('orderID')),
      expression: "errors.has('orderID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('orderID')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isValidAWB && _vm.isInitiated > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading1 || _vm.isOrderIdUpdated,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.updateOrderIdRVPGRN()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('createGRN.changeOrder')))])]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [(_vm.globalObject.merchantName) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.merchant')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderID) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderDate) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.orderDate')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.whReceivedDate) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.whReceivedDate')))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.transporter) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.transporter')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.globalObject.merchantName) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.merchantName))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderID) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.orderID))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.orderDate) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.globalObject.orderDate)))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.whReceivedDate) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.globalObject.whReceivedDate)))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.transporter) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.transporter))]) : _vm._e()])])])])]) : _vm._e()])])])])], 1)])]), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productDetails')) + " (" + _vm._s(this.globalObject.productDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.dispatchQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.productDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productDetailsNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.productDetails), function(data, index) {
    return (_vm.globalObject.productDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check3"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productQCTitle')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading3
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading3 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('productId')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('boxList.scanProduct'),
      "name": "productId",
      "id": "productId"
    },
    model: {
      value: (_vm.globalObject.productId),
      callback: function($$v) {
        _vm.globalObject.productId = $$v
      },
      expression: "globalObject.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm",
      "title": "Reset Product"
    },
    on: {
      "click": _vm.resetProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _vm._v(" "), (!_vm.isProductReject && _vm.showExpiryDate && !_vm.qcDoneReject) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('expirydate')
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('rtogrnb2b.expiryDatePlaceholder1'),
      "name": "expirydate",
      "id": "expirydate"
    },
    on: {
      "change": _vm.showQCButtonsForGrn
    },
    model: {
      value: (_vm.globalObject.expiryDate),
      callback: function($$v) {
        _vm.globalObject.expiryDate = $$v
      },
      expression: "globalObject.expiryDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP' && _vm.showrefurbished) ? _c('div', {
    staticClass: "col-md-12 my-2",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "margin-left": "-10px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isBoxchanged),
      expression: "isBoxchanged"
    }],
    attrs: {
      "type": "checkbox",
      "id": "boxchange1"
    },
    domProps: {
      "checked": Array.isArray(_vm.isBoxchanged) ? _vm._i(_vm.isBoxchanged, null) > -1 : (_vm.isBoxchanged)
    },
    on: {
      "change": function($event) {
        _vm.disabledAccept()
      },
      "__c": function($event) {
        var $$a = _vm.isBoxchanged,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isBoxchanged = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isBoxchanged = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isBoxchanged = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "boxchange"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.isBoxchange')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRefurbished),
      expression: "isRefurbished"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isRefurbished1"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRefurbished) ? _vm._i(_vm.isRefurbished, null) > -1 : (_vm.isRefurbished)
    },
    on: {
      "change": function($event) {
        _vm.disabledAccept()
      },
      "__c": function($event) {
        var $$a = _vm.isRefurbished,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRefurbished = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isRefurbished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRefurbished = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isRefurbished"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.isRefurbished')))])])]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.scanProductDetails.productQty),
      expression: "globalObject.scanProductDetails.productQty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.quantity'),
      "name": "productQty",
      "id": "productQty"
    },
    domProps: {
      "value": (_vm.globalObject.scanProductDetails.productQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalObject.scanProductDetails.productQty = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading3 || _vm.isRefurbished,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.productQC('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.accept')))]), _vm._v("  \n                            ")]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3 || _vm.isBoxchanged,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.productQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.reject')))])]) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.rejectReason),
      expression: "globalObject.rejectReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectReason')
    },
    attrs: {
      "name": "rejectReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.globalObject.rejectReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.reasonPlaceholder')))]), _vm._v(" "), _vm._l((_vm.globalObject.rejectList), function(reasontext) {
    return _c('option', {
      domProps: {
        "value": reasontext.reasontext
      }
    }, [_vm._v(_vm._s(reasontext.reasontext))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rejectReason')),
      expression: "errors.has('rejectReason')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.rejectReasonErr')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId && _vm.hideRejectbutton == false) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.completeProductQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.reject')))])]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.showQCButton) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.globalObject.scanProductDetails.productid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productId')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productType')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.globalObject.scanProductDetails.productid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.clientproductid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productname))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productdescription))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.globalObject.scanProductDetails.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productType))]) : _vm._e()])])])])]) : _vm._e()]), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType == 'NOP') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.imageDescription),
      expression: "imageDescription"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('imageDescription')
    },
    attrs: {
      "id": "imageDescription",
      "name": "imageDescription",
      "type": "text",
      "placeholder": _vm.$t('product.productType')
    },
    domProps: {
      "value": (_vm.imageDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageDescription = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.nopFound
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.markNop')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "10px",
      "background-color": "#673AB7"
    },
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printLabelNop
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.printNop')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "10px",
      "background-color": "#44b8bd"
    },
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printLabelNopPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.printNop')))])])]) : _vm._e(), _vm._v(" "), (_vm.uploadPictures) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProduct')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProductimg1')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProductimg2')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.uploadProductimg3')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.productUploadLabelUpload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadLabelUrl,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadLabelUrl)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadLabelUpload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.productUploadImage1Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadImage1Url,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadImage1Url)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadImage1Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.productUploadImage2Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadImage2Url,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadImage2Url)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadImage2Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.productUploadImage3Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadImage3Url,
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadImage3Url)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.productUploadImage3Upload) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Label"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('label', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Label"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('label', 'file')
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Image 1"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image1', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Image 1"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image1', 'file')
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Image 2"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image2', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Image 2"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image2', 'file')
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Upload Product Image 3"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image3', 'camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": "Select Product Image 3"
    },
    on: {
      "click": function($event) {
        _vm.uploadImage('image3', 'file')
      }
    }
  })])])])])]), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.cameraSection = false
      }
    },
    model: {
      value: (_vm.cameraSection),
      callback: function($$v) {
        _vm.cameraSection = $$v
      },
      expression: "cameraSection"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading7
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading7 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('label', [_c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.uploadProductID')) + " [ " + _vm._s(this.globalObject.productId) + " ] " + _vm._s(this.imageType) + " ")])])])]), _vm._v(" "), (_vm.uploadPictures && _vm.cameraSection && _vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage(_vm.imageType, 'file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")])])]) : _vm._e(), _vm._v(" "), (_vm.uploadPictures && _vm.cameraSection && !_vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cameralist),
      expression: "cameralist"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cameralist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cameralist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cameraSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _vm._l((_vm.cameras), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.deviceId
      }
    }, [_vm._v(" " + _vm._s(client_obj.label))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('web-cam', {
    ref: "cameraImage",
    attrs: {
      "autoplay": "autoplay",
      "playsinline": _vm.playsinline,
      "height": 500,
      "width": 455,
      "screenshotFormat": _vm.screenshotFormat,
      "selectFirstDevice": _vm.selectFirstDevice
    },
    on: {
      "cameras": _vm.camerass
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.captureImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.capture')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.resetImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.retake')))])]), _vm._v(" "), (this.imageCaptured) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.saveImage(_vm.imageType, 'camera')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.viewImage = false
      }
    },
    model: {
      value: (_vm.viewImage),
      callback: function($$v) {
        _vm.viewImage = $$v
      },
      expression: "viewImage"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "width": "400px",
      "height": "400px"
    }
  })])], 1)], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check4"
    }
  }, [_vm._v(_vm._s(_vm.$t('rvpgrnb2b.extraProduct')) + " (" + _vm._s(this.globalObject.extraProductDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading4
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading4 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.quantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productDescription')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productImage')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.extraProductDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.$t('rvpgrnb2b.extraProductNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.extraProductDetails), function(data, index) {
    return (_vm.globalObject.extraProductDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productdescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('img', {
      attrs: {
        "src": data.productimage,
        "width": "100px",
        "height": "120px"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check5"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.excessProduct')) + " (" + _vm._s(this.globalObject.externalProductDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading5
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading5 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('boxList.quantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productDescription')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productImage')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.externalProductDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.excessProductPlaceholder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.externalProductDetails), function(data, index) {
    return (_vm.globalObject.externalProductDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productdescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('img', {
      attrs: {
        "src": data.productimage,
        "width": "100px",
        "height": "120px"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e()])]), _vm._v(" "), (_vm.isValidAWB) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading6,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.checkCloseGR
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('rtogrnb2b.closeGR')))])])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Non-Intiated FRC Shipment"
    },
    on: {
      "click": function($event) {
        _vm.tabChanged(3)
      }
    }
  }, [(_vm.isFRC) ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isValidFRCOrderId) ? _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    }
  }, [_c('a', {
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('rtogrnb2b.expandAll')) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "checkbox",
      "id": "check1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check1"
    }
  }, [_vm._v("Create FRC Shipment")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading1
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading1 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    ref: "courier",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%",
      "overflow": "display"
    },
    attrs: {
      "id": "courier",
      "options": _vm.courierList1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.courierCompanyPlaceHolder'),
      "append-to-body": true
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.courier),
      callback: function($$v) {
        _vm.courier = $$v
      },
      expression: "courier"
    }
  })], 1), _vm._v(" "), (_vm.courier == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.couriererr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbNo')
    },
    attrs: {
      "type": "string",
      "disabled": _vm.isValidAWB,
      "placeholder": _vm.$t('handover.awbnoPlaceholder'),
      "name": "awbNo",
      "id": "awbNo",
      "append-to-body": true
    },
    model: {
      value: (_vm.globalObject.awbNo),
      callback: function($$v) {
        _vm.globalObject.awbNo = $$v
      },
      expression: "globalObject.awbNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbNo')),
      expression: "errors.has('awbNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('awbNo')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.scanFRCAwbNo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')) + "\n                              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')) + "\n                              ")])])])])], 1)]), _vm._v(" "), (_vm.isValidFRCAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check2"
    }
  }, [_vm._v("Suborder Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.isValidFRCAWB) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('orderID')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('common.orderIDPlaceholder'),
      "name": "orderID",
      "id": "orderID"
    },
    model: {
      value: (_vm.globalObject.orderID),
      callback: function($$v) {
        _vm.globalObject.orderID = $$v
      },
      expression: "globalObject.orderID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('orderID')),
      expression: "errors.has('orderID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('orderID')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isValidFRCAWB) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.validateFRCOrder()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('rvpgrnb2b.searchOrderBtn')))])]) : _vm._e()])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidFRCOrderId) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check3"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productDetails')) + " (" + _vm._s(this.globalObject.productDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.expectedQuantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.productDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productDetailsNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.productDetails), function(data, index) {
    return (_vm.globalObject.productDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.expected_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidFRCOrderId) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check3"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productQCTitle')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading3
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading3 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('productId')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('boxList.scanProduct'),
      "name": "productId",
      "id": "productId"
    },
    model: {
      value: (_vm.globalObject.productId),
      callback: function($$v) {
        _vm.globalObject.productId = $$v
      },
      expression: "globalObject.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanFRCProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm",
      "title": "Reset Product"
    },
    on: {
      "click": _vm.resetProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && _vm.isExpectedQty && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.scanProductDetails.expectedqty),
      expression: "globalObject.scanProductDetails.expectedqty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('returnReceiptReport.expectedQuantity'),
      "name": "expectedqty",
      "id": "expectedqty"
    },
    domProps: {
      "value": (_vm.globalObject.scanProductDetails.expectedqty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalObject.scanProductDetails.expectedqty = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.scanProductDetails.productQty),
      expression: "globalObject.scanProductDetails.productQty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.quantity'),
      "name": "productQty",
      "id": "productQty"
    },
    domProps: {
      "value": (_vm.globalObject.scanProductDetails.productQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalObject.scanProductDetails.productQty = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.productFRCQC('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.accept')))]), _vm._v("  \n                                            ")]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.productFRCQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.reject')))])]) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.rejectReason),
      expression: "globalObject.rejectReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectReason')
    },
    attrs: {
      "name": "rejectReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.globalObject.rejectReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.reasonPlaceholder')))]), _vm._v(" "), _vm._l((_vm.globalObject.rejectList), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.reason
      }
    }, [_vm._v(_vm._s(reason.reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rejectReason')),
      expression: "errors.has('rejectReason')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.rejectReasonErr')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId && _vm.hideRejectbutton == false) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.completeProductFRCQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reject")])]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.showQCButton) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.globalObject.scanProductDetails.productid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productType')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.globalObject.scanProductDetails.productid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.clientproductid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productname))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productdescription))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.globalObject.scanProductDetails.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productType))]) : _vm._e()])])])])]) : _vm._e()])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin-top": "10px"
    }
  }, [(_vm.isValidFRCOrderId) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading6,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeFrcSuborder
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Close FRC SuborderId")]) : _vm._e(), _vm._v(" "), (_vm.isValidFRCOrderId || _vm.iscloseAWB) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading6,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeFrcAWB
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Close FRC AWB")]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Intiated FRC Shipment"
    },
    on: {
      "click": function($event) {
        _vm.tabChanged(4)
      }
    }
  }, [(_vm.isIntiatedFRC) ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isValidFRCOrderId) ? _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    }
  }, [_c('a', {
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('rtogrnb2b.expandAll')) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "checkbox",
      "id": "check1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check1"
    }
  }, [_vm._v("Create Initiated FRC Shipment")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading1
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading1 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    ref: "courier",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%",
      "overflow": "display"
    },
    attrs: {
      "id": "courier",
      "options": _vm.courierList1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.courierCompanyPlaceHolder'),
      "append-to-body": true
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.courier),
      callback: function($$v) {
        _vm.courier = $$v
      },
      expression: "courier"
    }
  })], 1), _vm._v(" "), (_vm.courier == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.couriererr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbNo')
    },
    attrs: {
      "type": "string",
      "disabled": _vm.isValidAWB,
      "placeholder": _vm.$t('handover.awbnoPlaceholder'),
      "name": "awbNo",
      "id": "awbNo",
      "append-to-body": true
    },
    model: {
      value: (_vm.globalObject.awbNo),
      callback: function($$v) {
        _vm.globalObject.awbNo = $$v
      },
      expression: "globalObject.awbNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbNo')),
      expression: "errors.has('awbNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('awbNo')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.scanInititedFRCAwbNo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')) + "\n                              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading1,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')) + "\n                              ")])])])])], 1)]), _vm._v(" "), (_vm.isValidFRCAWB) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check2"
    }
  }, [_vm._v("Suborder Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.isValidFRCAWB) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('orderID')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('common.orderIDPlaceholder'),
      "name": "orderID",
      "id": "orderID",
      "disabled": true
    },
    model: {
      value: (_vm.globalObject.orderID),
      callback: function($$v) {
        _vm.globalObject.orderID = $$v
      },
      expression: "globalObject.orderID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('orderID')),
      expression: "errors.has('orderID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('orderID')))])], 1)], 1) : _vm._e()])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidFRCOrderId) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check3"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.productDetails')) + " (" + _vm._s(this.globalObject.productDetailsCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('returnReceiptReport.expectedQuantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('shipment.receivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])])]), _vm._v(" "), _c('tbody', [(_vm.globalObject.productDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productDetailsNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.globalObject.productDetails), function(data, index) {
    return (_vm.globalObject.productDetails.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.expected_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.total_quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(data.accepted_qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(data.rejected_qty))])]) : _vm._e()
  })], 2)])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isValidFRCOrderId) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    staticStyle: {
      "position": "absolute",
      "z-index": "-1"
    },
    attrs: {
      "type": "checkbox",
      "id": "check3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check3"
    }
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.productQCTitle')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading3
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading3 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    ref: "productIdInput",
    class: {
      'form-control': true,
      'error': _vm.errors.has('productId')
    },
    attrs: {
      "type": "string",
      "placeholder": _vm.$t('boxList.scanProduct'),
      "name": "productId",
      "id": "productId"
    },
    model: {
      value: (_vm.globalObject.productId),
      callback: function($$v) {
        _vm.globalObject.productId = $$v
      },
      expression: "globalObject.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanFRCProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.scan')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm",
      "title": "Reset Product"
    },
    on: {
      "click": _vm.resetProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && _vm.isExpectedQty && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.scanProductDetails.expectedqty),
      expression: "globalObject.scanProductDetails.expectedqty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('returnReceiptReport.expectedQuantity'),
      "name": "expectedqty",
      "id": "expectedqty"
    },
    domProps: {
      "value": (_vm.globalObject.scanProductDetails.expectedqty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalObject.scanProductDetails.expectedqty = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.scanProductDetails.productQty),
      expression: "globalObject.scanProductDetails.productQty"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('boxList.quantity'),
      "name": "productQty",
      "id": "productQty"
    },
    domProps: {
      "value": (_vm.globalObject.scanProductDetails.productQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalObject.scanProductDetails.productQty = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.productFRCGRNQC('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.accept')))]), _vm._v("  \n                                            ")]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.productFRCGRNQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.reject')))])]) : _vm._e(), _vm._v(" "), (!_vm.isProductReject && _vm.showQCButton && !_vm.qcDoneReject && _vm.globalObject.scanProductDetails.productType != 'NOP') ? _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-left": "50%"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.productFRCGRNQC('short')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Short ")])]) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalObject.rejectReason),
      expression: "globalObject.rejectReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectReason')
    },
    attrs: {
      "name": "rejectReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.globalObject.rejectReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.reasonPlaceholder')))]), _vm._v(" "), _vm._l((_vm.globalObject.rejectList), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.reason
      }
    }, [_vm._v(_vm._s(reason.reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rejectReason')),
      expression: "errors.has('rejectReason')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('rtogrnb2b.rejectReasonErr')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isProductReject && _vm.globalObject.productId && _vm.hideRejectbutton == false) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading3,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.completeProductGRNFRCQC('reject')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reject")])]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.showQCButton) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.globalObject.scanProductDetails.productid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.productType')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.globalObject.scanProductDetails.productid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.clientproductid) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.clientproductid))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productname) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productname))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productdescription) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productdescription))]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productimage) ? _c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.globalObject.scanProductDetails.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.globalObject.scanProductDetails.productType) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.globalObject.scanProductDetails.productType))]) : _vm._e()])])])])]) : _vm._e()])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin-top": "10px"
    }
  }, [(_vm.isValidFRCOrderId || _vm.iscloseAWB) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading6,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeInitiatedFRC
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Close FRC AWB")]) : _vm._e()])])])]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "printNOPContent"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "12px",
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "padding-bottom": "0px!important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "25%",
      "border": "none !important",
      "padding-bottom": "0px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "100%",
      "text-align": "Center!important",
      "font-size": "2em !important"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('rvpgrnb2b.nop')))])])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%",
      "border": "none !important",
      "padding-bottom": "0px"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%",
      "border": "none !important",
      "padding-bottom": "0px !important"
    }
  })]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "25%",
      "text-align": "left !important",
      "border": "none !important",
      "padding-top": "0px"
    }
  }, [_c('span', [_c('barcode', {
    attrs: {
      "value": _vm.globalObject.scanProductDetails.productid,
      "format": "CODE128",
      "font-options": "bold",
      "width": "2",
      "height": "30"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%",
      "border": "none !important",
      "padding-top": "0px"
    }
  }), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lm"
    },
    model: {
      value: (_vm.isModalVisible),
      callback: function($$v) {
        _vm.isModalVisible = $$v
      },
      expression: "isModalVisible"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Courier")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Courier Name:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCourierDetails),
      expression: "otherCourierDetails"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('otherCourierDetails')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Courier Name",
      "name": "otherCourierDetails",
      "id": "otherCourierDetails"
    },
    domProps: {
      "value": (_vm.otherCourierDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherCourierDetails = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.otherCourierDetailsError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.otherCourierDetailsError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.saveOtherCourier
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n                          " + _vm._s(_vm.$t('common.cancelBtn')) + "\n                        ")])])])])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "width": "25%",
      "text-align": "right !important",
      "border": "none !important",
      "padding-top": "0px"
    }
  }, [_c('span')])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f499993", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f499993","hasScoped":true}!./src/views/components/rtogrnb2b/rtogrnb2b.component.html
// module id = 1988
// module chunks = 0